<template>
  <NuxtLayout>
    <div
      v-loading="ctrl.loading"
      class="app_container detail_content"
    >
      <div
        v-if="opts.info.id"
        class="course_info"
      >
        <div
          ref="head"
          class="course_info_header"
        >
          <div class="course_info_content_box">
            <div class="course_info_content">
              <div class="course_nav">
                <el-breadcrumb :separator-icon="ArrowRight">
                  <el-breadcrumb-item :to="{ path: '/' }">
                    <span class="nav_course_title">首页</span>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item :to="{ path: '/course/list' }">
                    <span class="nav_course_title">课程中心</span>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item :to="{
                    path: '/course/list',
                    query: { courseType: opts.info.courseType },
                  }">
                    <span class="nav_course_title">{{ opts.PeriodTypeEnum[opts.info.courseType] }}</span>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item>
                    <div class="nav_course_title tx-ov">
                      {{ opts.info.courseName }}
                    </div>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <div class="course_message">
                <div class="course_cover">
                  <img
                    :src="opts.info.courseCover"
                    class="course_cover_img"
                  >
                  <div
                    v-if="opts.info.buyStatus"
                    :class="{
                      success: !opts.info.overSet,
                      danger: opts.info.overSet,
                    }"
                    class="update_status"
                  >
                    {{ !opts.info.overSet ? "更新中" : "已完结" }}
                  </div>
                </div>
                <div class="course_msg_content">
                  <div class="course_price_content">
                    <div class="course_name">
                      <span class="course_name_tag">{{ opts.PeriodTypeEnum[opts.info.courseType] }}</span>
                      <span>{{ opts.info.courseName }}</span>
                    </div>
                    <div class="course_int">
                      <div
                        class="course_int_text tx-ov"
                        style="width: 90px;"
                      >
                        课程描述：<!-- {{ opts.info.courseDesc || "无" }} -->
                      </div>
                      <client-only>
                        <el-popover
                          v-if="opts.info.courseDesc.length > 35"
                          :width="600"
                          placement="bottom-end"
                          :offset="-24"
                          :show-arrow="false"
                          trigger="hover"
                        >
                          <span class="course_desc_tip">{{ opts.info.courseDesc }}</span>
                          <!-- <template #reference>
                          <span class="loadmore">更多</span>
                        </template> -->
                          <template #reference>
                            <div class="course_int_text tx-ov">
                              {{ opts.info.courseDesc || "无" }}
                            </div>
                          </template>
                        </el-popover>
                      </client-only>
                    </div>
                  </div>
                  <div
                    class="course_price_info"
                    style="height: 39px; background: transparent;"
                  >
                    <!-- <div class="course_price">
                    <span class="course_tip">价格：</span>
                    <span
                      :style="{ color: '#F01414' }"
                      class="price_now"
                    >
                      <span
                        v-if="opts.info.price > 0"
                        class="price_icon"
                      >￥</span>
                      {{ opts.info.price ? opts.info.price.toFixed(2) : "免费" }}
                    </span>
                    <span
                      v-if="opts.info.linePrice > 0"
                      class="price_old"
                    >
                      <span class="price_icon">￥</span>
                      {{ opts.info.linePrice.toFixed(2) }}
                    </span>
                  </div>
                  <div
                    v-if="opts.info.price > 0 && shopData?.config?.vipEnableMarketing"
                    class="course_price mgt10"
                  >
                    <span class="course_tip">推荐会员价：</span>
                    <span
                      v-if="userInfo && userInfo.isVip"
                      :style="{ color: '#F01414' }"
                      class="discount_price"
                    >
                      ￥{{ opts.info.discountPrice.toFixed(2) }}
                    </span>
                    <span
                      v-else
                      :style="{ color: '#F01414' }"
                      class="discount_price"
                    >
                      ￥{{ opts.info.otherPrice.toFixed(2) }}
                    </span>
                  </div> -->
                  </div>
                  <div class="course_cell">
                    <span class="course_tip">包含内容：</span>
                    <span class="course_cell_item"><img src="@/assets/class.svg">&nbsp;课时数：{{ opts.info.resourceCount
                    }}个</span>
                    <span
                      v-if="opts.info.certIssue"
                      class="course_cell_item"
                    ><img src="@/assets/credential.svg">&nbsp;课程证书：1张
                    </span>
                  </div>
                  <div
                    v-if="opts.info.courseAuthor"
                    class="course_int"
                  >
                    <div class="course_int_text tx-ov">
                      课程作者：{{ opts.info.courseAuthor }}
                    </div>
                    <client-only>
                      <el-popover
                        v-if="opts.info.courseAuthor.length > 35"
                        :width="600"
                        placement="bottom-end"
                        :offset="-24"
                        :show-arrow="false"
                        trigger="hover"
                      >
                        <span class="course_desc_tip">{{ opts.info.courseAuthor }}</span>
                        <template #reference>
                          <span class="loadmore">更多</span>
                        </template>
                      </el-popover>
                    </client-only>
                  </div>
                  <div
                    v-if="opts.info.teacherExist"
                    class="course_cell"
                  >
                    <span class="course_tip">授课教师：</span>
                    <div class="flex_teacher">
                      <div class="course_cell_item teacher_wrap">
                        <div
                          v-for="(teacher, i) in opts.info.teacherList.filter(
                            (item, i) => i < 5
                          )"
                          class="teacher_warp_item"
                          @click="handleOpenTeacher(teacher)"
                        >
                          <img
                            :key="i"
                            :src="teacher.headImg"
                            :title="teacher.nickname"
                            class="mgl3 cover_teacher"
                          >
                          <div class="teacher_name">
                            {{ teacher.nickname }}
                          </div>
                        </div>
                      </div>
                      <client-only>
                        <el-popover
                          v-if="opts.info.teacherList.length > 5"
                          :content="opts.info.courseDesc"
                          :width="600"
                          placement="bottom-end"
                          :offset="-24"
                          :show-arrow="false"
                          trigger="hover"
                        >
                          <div class="course_cell_item">
                            <div
                              v-for="(teacher, i) in opts.info.teacherList"
                              class="teacher_warp_item"
                              @click="handleOpenTeacher(teacher)"
                            >
                              <img
                                :key="i"
                                :src="teacher.headImg"
                                :title="teacher.nickname"
                                class="mgl3 cover_teacher"
                              >
                              <div class="teacher_name">
                                {{ teacher.nickname }}
                              </div>
                            </div>
                          </div>
                          <template #reference>
                            <div
                              class="course_in_icon"
                              @click="handleChangeTeach"
                            >
                              更多
                            </div>
                          </template>
                        </el-popover>
                      </client-only>
                    </div>
                  </div>
                  <div class="course_cell course_cell_valid">
                    <span class="course_tip">有效期：</span>
                    <template v-if="opts.info.courseStatus === 3">
                      <span class="valid_text">已过期</span>
                    </template>
                    <template v-else>
                      <span v-if="opts.info.validityType === 1">永久有效</span>
                      <span v-else-if="opts.info.validityType === 2">
                        {{ opts.info.beginTime }} 至 {{ opts.info.endTime }}
                      </span>
                      <span v-else-if="opts.info.validityType === 3">
                        {{ opts.info.days }}天
                      </span>
                    </template>
                  </div>
                  <div class="course_bottom">
                    <div class="course_btn_info">
                      <div class="course_btn">
                        <template v-if="opts.info.courseStatus">
                          <el-button
                            v-if="opts.info.courseStatus === 1"
                            class="buy_btn"
                            type="primary"
                            @click="handleMake"
                          >
                            预约课程
                          </el-button>
                          <el-button
                            v-if="opts.info.courseStatus === 2"
                            class="buy_btn"
                            type="info"
                          >
                            待开课
                          </el-button>
                          <el-button
                            v-if="opts.info.courseStatus === 3"
                            class="buy_btn"
                            type="primary"
                            @click="handleOpenOther"
                          >
                            查看其它课程
                          </el-button>
                        </template>
                        <el-button
                          v-else
                          class="buy_btn"
                          type="primary"
                          :disabled="!opts.info.buyStatus && !opts.info.supportAloneSales
                            "
                          @click="handleBuy('learn')"
                        >
                          <template v-if="opts.info.supportAloneSales">
                            <template v-if="opts.info.buyStatus">
                              {{ !opts.info.enableFirst ? "继续学习" : "开始学习" }}
                            </template>
                            <template v-else>
                              {{ opts.info.price ? "购买" : "开始学习" }}
                            </template>
                          </template>
                          <template v-else>
                            <template v-if="opts.info.buyStatus">
                              {{ !opts.info.enableFirst ? "继续学习" : "开始学习" }}
                            </template>
                            <template v-else>
                              不支持单独售卖
                            </template>
                          </template>
                        </el-button>
                        <el-button
                          v-if="userInfo &&
                            shopData?.config?.vipEnableMarketing &&
                            !userInfo.isVip &&
                            opts.info.price > 0
                            "
                          class="buy_btn"
                          type="warning"
                          @click="openVip"
                        >
                          开通会员
                        </el-button>
                      </div>
                      <div class="course_learn_msg">
                        <span
                          v-if="shopData && shopData?.config?.showLearnUserCount && shopData?.config?.showCourseLearnUserCount"
                          class="learn_item"
                        >{{ opts.info.studyNum }}人已学习</span>
                        <span
                          class="learn_item icon_btn"
                          @click="handleCollection"
                        >
                          <span
                            :class="{
                              'icon-collection': !opts.info.collectStatus,
                              'icon-collections': opts.info.collectStatus,
                            }"
                            class="iconfont"
                          />
                          <span class="icon_text_name">收藏</span>
                        </span>
                        <span
                          class="learn_item icon_btn"
                          @click="handleShare"
                        >
                          <span class="iconfont icon-share" />
                          <span class="icon_text_name">分享</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nav_tabs">
            <template v-for="item in tabEnum">
              <div
                v-if="item.show"
                :key="item.command"
                :class="{ active: map.tabs === item.command }"
                class="nav_tabs_item"
                @click="handleChangeType(item.command)"
              >
                {{ item.label }}
              </div>
            </template>
          </div>
        </div>
        <div
          v-show="map.tabs === 'details'"
          class="detail_tab_pane"
        >
          <course-details :course-info="opts.info" />
        </div>
        <div
          v-if="map.tabs === 'directory'"
          class="detail_tab_pane"
        >
          <div class="menu_have_num">
            共{{ opts.subNum }}节课
          </div>
          <template v-if="opts.subjectList.length === 1">
            <div
              v-for="(sub, i) in opts.subjectList[0].periodList"
              :key="i"
              class="single_menu_item"
              @click="handleBuy(sub)"
            >
              <div class="single_item_top">
                <div class="single_item_name">
                  <img
                    v-if="sub.periodType === 1"
                    class="video_icon mgr10"
                    src="@/assets/video.svg"
                  >
                  <span
                    v-if="sub.periodType === 2"
                    class="video_icon iconfont icon-audio mgr10"
                  />
                  <span
                    v-if="sub.periodType === 6"
                    class="video_icon iconfont icon-img mgr10"
                  />
                  <span
                    v-if="sub.periodType === 7"
                    class="video_icon iconfont icon-live mgr10"
                  />
                  <span
                    v-if="sub.periodType === 4"
                    class="video_icon iconfont icon-video_class mgr10"
                  />
                  <img
                    v-if="sub.periodType === 3 &&
                      sub.periodName.indexOf('.doc') > -1
                      "
                    class="video_icon mgr10"
                    src="@/assets/icon_Word.svg"
                  >
                  <img
                    v-if="sub.periodType === 3 &&
                      sub.periodName.indexOf('.xls') > -1
                      "
                    class="video_icon mgr10"
                    src="@/assets/icon_Excel.svg"
                  >
                  <img
                    v-if="sub.periodType === 3 &&
                      sub.periodName.indexOf('.ppt') > -1
                      "
                    class="video_icon mgr10"
                    src="@/assets/icon_PPT.svg"
                  >
                  <img
                    v-if="sub.periodType === 3 &&
                      sub.periodName.indexOf('.pdf') > -1
                      "
                    class="video_icon mgr10"
                    src="@/assets/icon_PDF.svg"
                  >
                  <img
                    v-if="sub.periodType === 3 &&
                      sub.periodName.indexOf('.txt') > -1
                      "
                    class="video_icon mgr10"
                    src="@/assets/icon_txt.svg"
                  >
                  <img
                    v-if="sub.periodType === 5"
                    class="video_icon mgr10"
                    src="@/assets/audio_class.svg"
                  >
                  <img
                    v-if="sub.periodType === 8"
                    class="video_icon mgr10"
                    src="@/assets/icon_link.svg"
                  >
                  <div class="single_item_title tx-ov">
                    {{ sub.periodName }}
                  </div>
                  <!-- <span
                    v-if="sub.tryLearn"
                    class="tag_success"
                  >免费试学</span> -->
                  <span
                    v-if="sub.tryLearn"
                    class="tag_success"
                  >试学</span>
                  <div v-if="sub.periodType === 7">
                    ({{ sub.liveBeginTime }} 开播)
                  </div>
                </div>
                <div
                  v-if="[1, 2, 4, 5].indexOf(sub.periodType) > -1"
                  class="single_item_status"
                >
                  {{ formatDuring(sub.materialDuration * 1000) }}
                </div>
                <div
                  v-else-if="sub.periodType === 7"
                  class="single_item_status"
                >
                  <span
                    v-if="sub.liveStatus === 1"
                    class="tag_status"
                  >未开播</span>
                  <span
                    v-else-if="sub.liveStatus === 2"
                    class="tag_status success"
                  ><span class="iconfont icon-living mgr10" />正在直播
                  </span>
                  <span
                    v-else-if="sub.liveStatus === 3"
                    class="tag_status"
                  >
                    已结束
                  </span>
                  <span
                    v-else-if="sub.liveStatus === 4"
                    class="tag_status"
                  >
                    回放生成
                  </span>
                </div>
                <div
                  v-else-if="sub.periodType === 3"
                  class="single_item_status"
                >
                  {{ getSize(sub.materialSize) }}
                </div>
                <div
                  v-else-if="sub.periodType === 6"
                  class="single_item_status"
                >
                  预计阅读时间需要{{ (sub.duration / 60).toFixed(0) }}分钟
                </div>
              </div>
              <div
                v-if="sub.practiceExist || sub.examExist || sub.coursewareExist"
                class="btn_course_class"
              >
                <div
                  v-if="sub.practiceExist"
                  class="course_class_item"
                  @click.stop="handlePractice(sub)"
                >
                  <span class="iconfont icon-practice" />
                  <span class="course_btn_item_txt">练习</span>
                </div>
                <div
                  v-if="sub.examExist"
                  class="course_class_item"
                  @click.stop="handleExam(sub)"
                >
                  <span class="iconfont icon-examination" />
                  <span class="course_btn_item_txt">考试</span>
                </div>
                <div
                  v-if="sub.coursewareExist"
                  class="course_class_item"
                  @click.stop="handleOpenCourseware(sub)"
                >
                  <span class="iconfont icon-download" />
                  <span class="course_btn_item_txt">课件</span>
                </div>
              </div>
            </div>
          </template>
          <template v-if="opts.subjectList.length > 1">
            <div
              v-for="(subject, index) in opts.subjectList"
              :key="index"
              class="sub_menu_period"
            >
              <div class="sub_period_title">
                {{ subject.chapterName }}
              </div>
              <div
                v-for="(sub, i) in subject.periodList"
                :key="i"
                class="sub_period_item"
                @click="handleBuy(sub)"
              >
                <div class="single_item_top">
                  <div class="single_item_name">
                    <img
                      v-if="sub.periodType === 1"
                      class="video_icon mgr10"
                      src="@/assets/video.svg"
                    >
                    <span
                      v-if="sub.periodType === 2"
                      class="video_icon iconfont icon-audio mgr10"
                    />
                    <span
                      v-if="sub.periodType === 6"
                      class="video_icon iconfont icon-img mgr10"
                    />
                    <span
                      v-if="sub.periodType === 7"
                      class="video_icon iconfont icon-live mgr10"
                    />
                    <span
                      v-if="sub.periodType === 4"
                      class="video_icon iconfont icon-video_class mgr10"
                    />
                    <img
                      v-if="sub.periodType === 3 &&
                        sub.periodName.indexOf('.doc') > -1
                        "
                      class="video_icon mgr10"
                      src="@/assets/icon_Word.svg"
                    >
                    <img
                      v-if="sub.periodType === 3 &&
                        sub.periodName.indexOf('.xls') > -1
                        "
                      class="video_icon mgr10"
                      src="@/assets/icon_Excel.svg"
                    >
                    <img
                      v-if="sub.periodType === 3 &&
                        sub.periodName.indexOf('.ppt') > -1
                        "
                      class="video_icon mgr10"
                      src="@/assets/icon_PPT.svg"
                    >
                    <img
                      v-if="sub.periodType === 3 &&
                        sub.periodName.indexOf('.pdf') > -1
                        "
                      class="video_icon mgr10"
                      src="@/assets/icon_PDF.svg"
                    >
                    <img
                      v-if="sub.periodType === 3 &&
                        sub.periodName.indexOf('.txt') > -1
                        "
                      class="video_icon mgr10"
                      src="@/assets/icon_txt.svg"
                    >
                    <img
                      v-if="sub.periodType === 5"
                      class="video_icon mgr10"
                      src="@/assets/audio_class.svg"
                    >
                    <div
                      :class="{ mgr10: sub.periodType === 7 }"
                      class="single_item_title tx-ov"
                    >
                      {{ sub.periodName }}
                    </div>
                    <!-- <span
                      v-if="sub.tryLearn"
                      class="tag_success"
                    >免费试学</span> -->
                    <span
                      v-if="sub.tryLearn"
                      class="tag_success"
                    >试学</span>
                    <div v-if="sub.periodType === 7">
                      ({{ sub.liveBeginTime }} 开播)
                    </div>
                  </div>
                  <div
                    v-if="[1, 2, 4, 5].indexOf(sub.periodType) > -1"
                    class="single_item_status"
                  >
                    {{ formatDuring(sub.materialDuration * 1000) }}
                  </div>
                  <div
                    v-else-if="sub.periodType === 7"
                    class="single_item_status"
                  >
                    <span
                      v-if="sub.liveStatus === 1"
                      class="tag_status"
                    >未开播</span>
                    <span
                      v-else-if="sub.liveStatus === 2"
                      class="tag_status success"
                    ><span class="iconfont icon-living mgr10" />正在直播
                    </span>
                    <span
                      v-else-if="sub.liveStatus === 3"
                      class="tag_status"
                    >
                      已结束
                    </span>
                    <span
                      v-else-if="sub.liveStatus === 4"
                      class="tag_status"
                    >
                      回放生成
                    </span>
                  </div>
                  <div
                    v-else-if="sub.periodType === 3"
                    class="single_item_status"
                  >
                    {{ getSize(sub.materialSize) }}
                  </div>
                  <div
                    v-else-if="sub.periodType === 6"
                    class="single_item_status"
                  >
                    预计阅读时间需要{{ (sub.duration / 60).toFixed(0) }}分钟
                  </div>
                </div>
                <div
                  v-if="sub.practiceExist || sub.examExist || sub.coursewareExist
                    "
                  class="btn_course_class"
                >
                  <div
                    v-if="sub.practiceExist"
                    class="course_class_item"
                    @click.stop="handlePractice(sub)"
                  >
                    <span class="iconfont icon-practice" />
                    <span class="course_btn_item_txt">练习</span>
                  </div>
                  <div
                    v-if="sub.examExist"
                    class="course_class_item"
                    @click.stop="handleExam(sub)"
                  >
                    <span class="iconfont icon-examination" />
                    <span class="course_btn_item_txt">考试</span>
                  </div>
                  <div
                    v-if="sub.coursewareExist"
                    class="course_class_item"
                    @click.stop="handleOpenCourseware(sub)"
                  >
                    <span class="iconfont icon-download" />
                    <span class="course_btn_item_txt">课件</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div
          v-show="map.tabs === 'notes'"
          class="detail_tab_pane note_pane"
        >
          <course-notes :course-info="opts.info" />
        </div>

        <div
          v-show="map.tabs === 'comments'"
          class="detail_tab_pane"
        >
          <course-comment :course-info="opts.info" />
        </div>

        <div
          v-show="map.tabs === 'courseware'"
          class="detail_tab_pane"
        >
          <course-ware :course-info="opts.info" />
        </div>

        <div
          v-if="ctrl.fixed"
          class="fixed_header"
        >
          <div class="fixed_content">
            <a
              class="nav_logo"
              href="/"
            >
              <img
                v-if="componentInfo.websiteLogo"
                :src="componentInfo.websiteLogo"
                alt=""
              >
            </a>
            <div class="nav_tabs_header">
              <template v-for="item in tabEnum">
                <div
                  v-if="item.show"
                  :key="item.command"
                  :class="{ active: map.tabs === item.command }"
                  class="nav_tabs_item"
                  @click="handleChangeType(item.command)"
                >
                  {{ item.label }}
                </div>
              </template>
              <!--<div class="nav_tabs_item" @click="handleChangeType('details')" :class="{active:map.tabs === 'details'}">详情</div>
             <div class="nav_tabs_item" @click="handleChangeType('directory')" :class="{active:map.tabs === 'directory'}">目录</div>
             <div class="nav_tabs_item" @click="handleChangeType('notes')" :class="{active:map.tabs === 'notes'}">笔记</div>
             <div class="nav_tabs_item" @click="handleChangeType('comments')" :class="{active:map.tabs === 'comments'}">评论</div>
            <div class="nav_tabs_item" @click="handleChangeType('courseware')" :class="{active:map.tabs === 'courseware'}">课件</div> -->
            </div>
            <div class="course_btn">
              <template v-if="opts.info.courseStatus">
                <el-button
                  v-if="opts.info.courseStatus === 1"
                  class="buy_btn"
                  type="primary"
                  @click="handleMake"
                >
                  预约课程
                </el-button>
                <el-button
                  v-if="opts.info.courseStatus === 2"
                  class="buy_btn"
                  type="info"
                >
                  待开课
                </el-button>
                <el-button
                  v-if="opts.info.courseStatus === 3"
                  class="buy_btn"
                  type="primary"
                  @click="handleOpenOther"
                >
                  查看其它课程
                </el-button>
              </template>
              <el-button
                v-else
                class="buy_btn"
                type="primary"
                :disabled="!opts.info.buyStatus && !opts.info.supportAloneSales"
                @click="handleBuy('learn')"
              >
                <template v-if="opts.info.supportAloneSales">
                  <template v-if="opts.info">
                    {{ !opts.info.enableFirst ? "继续学习" : "开始学习" }}
                  </template>
                  <template v-else>
                    {{ opts.info.price ? "购买" : "开始学习" }}
                  </template>
                </template>
                <template v-else>
                  <template v-if="opts.info.buyStatus">
                    {{ !opts.info.enableFirst ? "继续学习" : "开始学习" }}
                  </template>
                  <template v-else>
                    不支持单独售卖
                  </template>
                </template>
              </el-button>
              <el-button
                v-if="userInfo &&
                  shopData?.config?.vipEnableMarketing &&
                  !userInfo.isVip &&
                  opts.info.price > 0
                  "
                class="buy_btn"
                type="warning"
                @click="openVip"
              >
                开通会员
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <client-only>
        <course-share
          v-model="ctrl.share"
          :info="opts.info"
        />
        <before-exam
          v-if="ctrl.showBeforeExam"
          :chapter-id="opts.examObj.chapterId"
          :dialog-visible="ctrl.showBeforeExam"
          :exam-name="opts.examObj.examName"
          :paper-id="opts.examObj.paperId"
          :period-id="opts.examObj.periodId"
          :resource-id="opts.examObj.courseId"
          :resource-type="2"
          :single-course-id="opts.examObj.resourceId"
          @close="closeDialog"
        />
        <before-exercise
          v-if="ctrl.showBeforeExercise"
          v-model="ctrl.showBeforeExercise"
          :practice-num="opts.examObj.practiceNum"
          :exam-name="opts.examObj.practiceName"
          :support-alone-sales="opts.info.supportAloneSales"
          @close="handleCloseExercise"
          @callback="handleOpenExercise"
        />
        <el-dialog
          v-model="ctrl.courseware"
          :before-close="handleCloseCourseware"
          title="课件下载"
          width="600px"
        >
          <div class="down_courseware_list">
            <div
              v-for="item in opts.coursewareList"
              :key="item.id"
              class="down_menu_item"
            >
              <div class="down_item_name">
                <span
                  class="iconfont icon-download mgr10"
                  @click="handleDown(item)"
                />
                <div class="down_item_title tx-ov">
                  {{ item.materialName }}
                </div>
              </div>
              <div class="down_item_status">
                {{ getSize(item.materialSize) }}
              </div>
            </div>
          </div>
        </el-dialog>
      </client-only>
      <div
        v-if="ctrl.showTip"
        class="tip_bg_visible"
      >
        <span class="tip_bg_visible"><el-icon><warning-filled /></el-icon></span>
        <div class="tip_visible_text">
          {{ opts.tipText }}
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>
<script setup>
import { ArrowRight, WarningFilled } from '@element-plus/icons-vue'
import { useUserStore } from '../../stores/user'
import {
  courseApiListCourseware,
  courseAuthAppointment,
  courseAuthSubjectMenuView,
  courseListCourseware,
  courseSubjectMenuView,
  coursewareDownloadApi,
  coursewareDownloadAuth,
  getAuthCourseView,
  getCourseView,
  handleBeforeValid
} from '../../api/course'
import { vipUserGoodsDiscount, authVipUserGoodsDiscount } from '@/api/vip'
import { formatDuring, getSize } from '../../utils'
import { getHearder } from '@/api/layouts'
import cookie from '@/utils/cookies'
import { collectionUserDelete, collectionUserSave } from '../../api/system'
import { ElMessage, ElMessageBox } from 'element-plus'
import { paperCheckStatus } from '../../api/paper'
import BeforeExercise from '@/components/exam/beforeExercise.vue'
import BeforeExam from '@/components/exam/beforeExam.vue'
import { setStore } from '../../utils/storage'
const route = useRoute()

const { data: componentInfo } = await useAsyncData('header', async (ctx) => {
  return getHearder()
})

const cookieData = cookie.getShop()

const { getEnumList, getToken, shopData } = useUserStore()
const tabEnum = computed(() => {
  return [
    { label: '课程介绍', command: 'details', show: true },
    { label: '课程目录', command: 'directory', show: true },
    {
      label: '课件下载',
      command: 'courseware',
      show: opts.info && opts.info.coursewareExist
    },
    {
      label: '学习笔记',
      command: 'notes',
      show: opts.info && opts.info.enableCourseNote
    },
    {
      label: '课程评论',
      command: 'comments',
      show: opts.info && opts.info.enableCourseComment
    }
  ]
})

const opts = reactive({
  tipText: '',
  errorNum: 0,
  info: {
    discountPrice: 0,
    otherPrice: 0
  },
  examObj: {},
  lastLearn: {},
  subjectList: [],
  subNum: computed(() => {
    let num = 0
    if (opts.subjectList.length > 0) {
      opts.subjectList.forEach((el) => {
        num += el.recourseNum
      })
    }
    return num
  }),
  PeriodTypeEnum: {}
})

const token = computed(() => {
  return getToken()
})

const router = useRouter()
const store = useUserStore()
const head = ref(null)
const userInfo = computed(() => store.userView)
const map = reactive({
  id: '',
  topicCourseId: '',
  tabs: 'details',
  relevanceType: 2, // 1:课程关联、2:专题关联
  recordId: '' // 考试记录id
})
if (route.query.id) {
  map.id = route.query.id
}
if (route.query.topicId) {
  map.topicCourseId = route.query.topicId
}

const ctrl = reactive({
  showTip: false,
  loading: false,
  showDesc: false,
  coursewareLoading: false,
  fixed: false,
  share: false,
  showStartPractice: false,
  showBeforeExam: false,
  showBeforeExercise: false
})
const closeDialog = (flag = false) => {
  ctrl.showBeforeExam = false
  if (flag) {
    setStore('examInfo', opts.examObj)
    router.push({
      path: '/exam/startExam',
      query: {
        controlShow: true,
        examType: 2,
        relevanceType: map.relevanceType
      }
    })
  }
}
const handleOpenExercise = () => {
  ctrl.showBeforeExercise = false
  // ctrl.showStartPractice = true
  setStore('practiceInfo', opts.examObj)
  router.push({
    path: '/practice/startPractice',
    query: {
      controlShow: true,
      examType: 2,
      courseId: opts.examObj.resourceId,
      subjectCourseId: opts.examObj.courseId,
      periodId: opts.examObj.id,
      courseTypeName: 'subject'
    }
  })
}
const handleCloseExercise = () => {
  ctrl.showBeforeExercise = false
}
const handlePractice = (row) => {
  if (!token.value) {
    ElMessage.error('你尚未登录')
    router.push({
      path: '/login',
      query: {
        redirect: encodeURIComponent(route.fullPath)
      }
    })
    return false
  }
  if (!opts.info.buyStatus && opts.info.price > 0) {
    ElMessage.error('你尚未购买本课程')
    return false
  }
  if (!handleBeforeValid(opts.info)) {
    return false
  }
  opts.examObj = row
  ctrl.showBeforeExercise = true
}
const handleExam = (row) => {
  if (!token.value) {
    ElMessage.error('你尚未登录')
    router.push({
      path: '/login',
      query: {
        redirect: encodeURIComponent(route.fullPath)
      }
    })
    return false
  }
  if (!opts.info.buyStatus && !opts.info.supportAloneSales) {
    ElMessage.error(
      '你尚未购买本课程，请从课程介绍中查看包含课程的套餐中购买后查看'
    )
    return false
  }
  if (!opts.info.buyStatus && opts.info.price > 0) {
    ElMessage.error('你尚未购买本课程')
    return false
  }
  if (!handleBeforeValid(opts.info)) {
    return false
  }
  if (token.value) {
    paperCheckStatus(row.paperId)
      .then((res) => {
        if (res === 1) {
          opts.examObj = row
          opts.examObj.scoreRecordRule = opts.info.scoreRecordRule
          opts.examObj.chapterId = row.chapterId
          opts.examObj.periodId = row.id
          ctrl.showBeforeExam = true
        } else {
          ElMessage.error('该试卷已下架')
        }
      })
  } else {
    opts.examObj = row
    opts.examObj.scoreRecordRule = opts.info.scoreRecordRule
    opts.examObj.chapterId = row.chapterId
    opts.examObj.periodId = row.id
    ctrl.showBeforeExam = true
  }
}
const handleOpenCourseware = (row) => {
  if (token.value) {
    courseListCourseware({
      id: opts.info.id,
      periodId: row.id,
      topicCourseId: map.topicCourseId
    }).then((res) => {
      opts.periodId = row.id
      opts.coursewareList = res
      ctrl.courseware = true
    })
  } else {
    courseApiListCourseware({
      id: opts.info.id,
      periodId: row.id,
      topicCourseId: map.topicCourseId
    }).then((res) => {
      opts.periodId = row.id
      opts.coursewareList = res
      ctrl.courseware = true
    })
  }
}
const handleCloseCourseware = () => {
  ctrl.courseware = false
}
const handleShowTip = (text) => {
  // 提示框
  opts.tipText = text
  ctrl.showTip = true
  setTimeout(() => {
    ctrl.showTip = false
  }, 3000)
}
const handleShare = () => {
  // 分享
  ctrl.share = true
}

const handleDown = (row) => {
  // 下载
  if (!handleBeforeValid(opts.info)) {
    return false
  }
  if (!opts.info.enableNotLoginWatch && !token.value) {
    router.push({
      path: '/login',
      query: {
        redirect: encodeURIComponent(route.fullPath)
      }
    })
    return false
  }
  getDwnUrl(row)
}
const getDwnUrl = async (row) => {
  let url = ''
  if (token.value) {
    url = await coursewareDownloadAuth({
      id: route.query.id,
      materialId: row.materialId,
      periodId: opts.periodId
    })
  } else {
    url = await coursewareDownloadApi({
      id: route.query.id,
      materialId: row.materialId,
      periodId: opts.periodId
    })
  }
  const link = document.createElement('a')
  link.href = url
  link.download = row.materialName
  link.click()
}

const handleMake = () => {
  // 预约
  if (!token.value) {
    router.push({
      path: '/login',
      query: {
        redirect: encodeURIComponent(route.fullPath)
      }
    })
    return
  }
  courseAuthAppointment({ id: opts.info.id }).then((res) => {
    if (res) {
      ElMessageBox.alert(
        '课程开课时，我们将以短信的形式通知您，请您留意哟~',
        '预约成功提醒',
        {
          confirmButtonText: '知道了',
          type: 'success',
          center: true
        }
      )
      opts.info.courseStatus = 2
    }
  })
}
const handleBuy = (row) => {
  // 购买
  if (!handleBeforeValid(opts.info)) {
    return false
  }
  if (opts.info.courseStatus === 1) {
    handleMake()
    return
  }
  if (opts.info.courseStatus === 2) {
    return
  }
  if (opts.info.courseStatus === 3) {
    handleOpenOther()
    return
  }
  if (!opts.info.buyStatus && !opts.info.supportAloneSales) {
    ElMessage.error(
      '你尚未购买本课程，请从课程介绍中查看包含课程的套餐中购买后查看'
    )
    return false
  }
  if (opts.info.price > 0 && !row.tryLearn && !opts.info.buyStatus) {
    if (!shopData?.config?.enabledPay) {
      ElMessage.error(shopData?.config?.disablePayTips)
      return
    }
    if (!shopData?.config?.enabledAliPay && !shopData?.config?.enabledWxPay) {
      handleShowTip(shopData?.config?.disablePayTips)
      return
    }
  }
  if (opts.info.price > 0 && !opts.info.buyStatus && !row.tryLearn) {
    if (!opts.info.publishStatus) {
      ElMessage.error('课程暂未发布')
      return false
    }
    if (token.value) {
      router.push({
        path: '/pay/buy',
        query: {
          id: map.id
        }
      })
    } else {
      router.push({
        path: '/login',
        query: {
          redirect: encodeURIComponent(route.fullPath)
        }
      })
    }
  } else {
    let obj
    if (row === 'learn') {
      if (!opts.info.enableFirst) {
        // 继续学习
        obj = {
          id: opts.info.authCourseLastWatchResp.superiorResourceId[1]
        }
      } else {
        for (let i = 0; i < opts.subjectList.length; i++) {
          if (
            opts.subjectList[i].periodList &&
            opts.subjectList[i].periodList.length
          ) {
            // 查询到章节存在课时，选择存在课时的章节第一个课时开始学习，并退出循环
            obj = opts.subjectList[i].periodList[0]
            i = opts.subjectList.length
          }
        }
        // 如果没有课程下没有课时，进行提示
        if (!obj) {
          ElMessage.error('课程暂无课时学习')
        }
      }
    } else {
      obj = row
    }
    if (
      !opts.info.enableNotLoginWatch &&
      !opts.info.buyStatus &&
      opts.info.price > 0 &&
      !token.value &&
      !row.tryLearn
    ) {
      ElMessage.error('请登录后再进行观看')
      router.push({
        path: '/login',
        query: {
          redirect: encodeURIComponent(route.fullPath)
        }
      })
      return
    }

    const query = route.query || {}
    const param = {
      id: map.id,
      periodId: obj.id
    }
    if (map.topicCourseId) {
      param.topicId = map.topicCourseId
    }
    router.push({
      path: '/course/combine',
      query: Object.assign(query, param)
    })
  }
}

const handleOpenOther = () => {
  router.push({
    path: '/course/list'
  })
}

// tabs切换
const handleChangeType = (item) => {
  map.tabs = item
  if (map.tabs === 'directory' && opts.subjectList.length === 0) {
    getMenuList()
  }
}
const getMenuList = () => {
  // 专题课目录
  if (token.value) {
    courseAuthSubjectMenuView({ id: map.id }).then((res) => {
      opts.subjectList = res
    })
  } else {
    courseSubjectMenuView({ id: map.id }).then((res) => {
      opts.subjectList = res
    })
  }
}
const handleScrollBody = () => {
  // if(opts.info.buyStatus ===1){
  //   return false
  // }
  const app = document.querySelector('#app')
  const top = Math.floor(app.scrollTop || window.pageYOffset)
  if (top >= head.value.clientHeight - 10) {
    ctrl.fixed = true
  } else {
    ctrl.fixed = false
  }
}
const handleCollection = () => {
  // 收藏
  if (ctrl.isClick) {
    return false
  }
  ctrl.isClick = true
  if (!token.value) {
    const route = useRoute()
    router.push({
      path: '/login',
      query: {
        redirect: encodeURIComponent(route.fullPath)
      }
    })
    return
  }
  if (opts.info.collectStatus) {
    collectionUserDelete({ collectionType: 1, resourceId: opts.info.id })
      .then((res) => {
        ElMessage.success(res)
        ctrl.isClick = false
        opts.info.collectStatus = false
      }).catch(() => {
        ctrl.isClick = false
      })
  } else {
    collectionUserSave({ collectionType: 1, resourceId: opts.info.id })
      .then((res) => {
        ElMessage.success(res)
        ctrl.isClick = false
        opts.info.collectStatus = true
      }).catch(() => {
        ctrl.isClick = false
      })
  }
}

// 教师详情
const handleOpenTeacher = (teacher) => {
  router.push({
    path: '/tch/view',
    query: {
      id: teacher.id
    }
  })
}

const { data, pending } = await useAsyncData(
  'subject' + route.query.id,
  async () => {
    return new Promise((resolve) => {
      let fn = getCourseView
      let menuFn = courseSubjectMenuView
      if (token.value) {
        fn = getAuthCourseView
        menuFn = courseAuthSubjectMenuView
      }
      Promise.allSettled([
        fn(map),
        getEnumList('CourseTypeEnum', 'obj'),
        menuFn({ id: map.id })
      ]).then(
        ([course, PeriodTypeEnum, menu]) => {
          const data = {}
          if (course.status === 'fulfilled') {
            data.course = course.value
          } else {
            data.course = {}
          }
          if (PeriodTypeEnum.status === 'fulfilled') {
            data.PeriodTypeEnum = PeriodTypeEnum.value
          } else {
            data.PeriodTypeEnum = []
          }
          if (menu.status === 'fulfilled') {
            data.menu = menu.value
          } else {
            data.menu = []
          }
          resolve(data)
        },
        (err) => {
          console.error(err)
        }
      )
    })
  },
  { initialCache: false }
)

if (data.value && !pending.value) {
  const d = data.value
  opts.info = { ...opts.info, ...d.course }
  if (shopData?.config?.vipEnableMarketing) {
    const fn = token.value ? authVipUserGoodsDiscount : vipUserGoodsDiscount
    fn({
      goodsId: opts.info.id,
      goodsType: opts.info.courseType
    }).then(res => {
      if (res) {
        opts.info = {
          ...opts.info,
          ...res
        }
      }
    })
  }
  opts.PeriodTypeEnum = d.PeriodTypeEnum
  opts.subjectList = d.menu
  useHead({
    title: computed(
      () =>
        `${opts.info.courseName
          ? opts.info.courseName + '-' + cookieData.shopName
          : '专题课详情'
        }`
    ),
    meta: [
      {
        hid: 'keywords',
        name: 'keywords',
        content: opts.info.courseName
      },
      {
        hid: 'description',
        name: 'description',
        content: opts.info.courseDesc
          ? opts.info.courseDesc
          : opts.info.courseName
      }
    ]
  })
}

const openVip = () => {
  router.push({
    path: '/vip'
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScrollBody, true)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScrollBody, true)
})
</script>

<style lang="scss" scoped>
.app_container {
  width: 100%;
}

.down_menu_item {
  display: flex;
  padding: 20px;
  justify-content: space-between;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #999999;
  border-bottom: 1px solid #ebeef5;

  .down_item_name {
    display: flex;
    align-items: center;
  }

  .iconfont {
    color: #333333;
    font-size: 24px;
  }
}

.course_desc_tip {
  line-height: 1.6;
  font-size: 14px;
  color: #999
}

.course_info_content_box {
  width: 100%;
  background: linear-gradient(rgb(209, 234, 231), #fff);
}

.course_info_content {
  padding: 20px calc((100vw - 1200px) / 2);
  border-top: 1px solid #ebeef5;
}

.nav_tabs_header {
  background-color: #ffffff;
  display: flex;
  flex: 1;
  padding-left: 60px;

  .nav_tabs_item {
    display: flex;
    align-items: center;
    margin-right: 50px;
    font-size: 16px;
    line-height: 65px;
    white-space: nowrap;
  }

  .nav_tabs_item:hover {
    cursor: pointer;
    position: relative;
    color: var(--el-color-primary);
  }

  .nav_tabs_item:hover::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 64px;
    height: 3px;
    border-radius: 1.5px;
    background-color: var(--el-color-primary);
  }

  .active {
    position: relative;
    color: var(--el-color-primary);
  }

  .active::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 64px;
    height: 3px;
    border-radius: 1.5px;
    background-color: var(--el-color-primary);
  }
}

.nav_tabs {
  padding: 20px calc((100vw - 1200px) / 2) 0;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;

  .nav_tabs_item {
    margin-right: 60px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    padding-bottom: 20px;
    color: #333333;
    position: relative;
    cursor: pointer;
  }

  .nav_tabs_item.active,
  .nav_tabs_item:hover {
    color: #2256f6;

    &:before {
      content: "";
      position: absolute;
      bottom: 0;
      background: #2256f6;
      width: 64px;
      padding-top: 3px;
      left: 0;
      border-radius: 10px;
    }
  }

  .nav_tabs_item:last-child {
    margin-right: 0;
  }
}

.course_nav {
  margin-bottom: 20px;
}

.nav_course_title {
  color: #888;
  font-weight: 400;
  max-width: 115px;
}

.course_name_tag {
  padding: 5px 3px;
  border-radius: 5px 0;
  background: rgba(61, 127, 255, 0.1);
  display: inline-block;
  font-style: normal;
  width: 46px;
  position: relative;
  top: -2px;
  text-align: center;
  font-weight: normal;
  font-size: 10px;
  color: #3d7fff;
  margin-right: 4px;
}

.course_cover_img {
  width: 576px;
  height: 320px;
  object-fit: cover;
  border-radius: 5px;
}

.course_name {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
}

.course_price_content {
  width: 100%;
}

.course_msg_content {
  width: 589px;
  margin-left: 30px;
  position: relative;
}

.course_message {
  display: flex;
  position: relative;
}

.course_int {
  margin-top: 5px;
  display: flex;

  .course_in_icon {
    min-width: 28px;
    margin-left: 8px;
    color: #666666;
    cursor: pointer;
  }

  .course_int_text {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #999999;
    width: 570px;
  }

  .loadmore {
    font-size: 14px;
    color: #666;
  }
}

.course_cell {
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;

  &+.course_cell {
    margin-top: 12px;
  }

  .course_cell_item {
    white-space: nowrap;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #333333;
    display: flex;
    align-items: center;
  }

  .course_cell_item+.course_cell_item {
    padding-left: 24px;
    position: relative;
  }
}

.mgl3 {
  margin-left: 3px;
}

.price_old {
  color: #999999;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  text-decoration-line: line-through;
  margin-left: 5px;
}

.price_now {
  font-style: normal;
  font-weight: bold;
  font-size: 26px;
  color: #f01414;
}

.discount_price {
  font-size: 16px;
  color: #f61818;
}

.price_now .price_icon {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  color: #f61818;
}

.course_btn_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
}

.buy_btn {
  width: 154px;
  height: 40px;
  font-size: 16px;
}

.course_learn_msg {
  display: flex;
  align-items: center;
}

.learn_item {
  position: relative;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #999999;

  &+.learn_item {
    padding-left: 20px;
  }
}

.icon_text_name {
  margin-left: 3px;
}

.icon_btn {
  cursor: pointer;

  .iconfont {
    //margin-right: 5px;
  }
}

.detail_tab_pane {
  padding: 30px;
  background-color: #ffffff;
  border-radius: 5px;
  width: 1200px;
  margin: 10px auto auto;
}

.slide-forward-leave-active {
  transition: all 1s;
  transform: translate(-100%);
}

// router2
.v-enter {
  transform: translateX(100%);
}

.v-enter-active {
  transition: all 3s;
}

.single_item_title {
  max-width: 550px;
}

.single_item_name .video_icon {
  font-size: 24px;
}

.single_item_name {
  display: flex;
  align-items: center;
}

.single_menu_item {
  display: flex;
  padding: 20px;
  flex-direction: column;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #999999;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;

  .single_item_top {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &:hover {
    background: rgba(34, 86, 246, 0.05);
  }

  .tag_status.success {
    color: #2256f6;
  }

  .tag_status.success .iconfont {
    color: #2256f6;
  }
}

.course_bottom {
  margin-top: 29px;
  width: 100%;
}

.fixed_header {
  position: fixed;
  top: 0;
  height: 66px;
  background-color: #ffffff;
  width: 100%;
  z-index: 10000;

  .fixed_content {
    width: 1200px;
    height: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .nav_logo {
    width: 170px;
    height: 36px;

    img {
      width: 170px;
      height: 36px;
      object-fit: cover;
    }
  }
}

.detail_content {
  min-height: 100%;
}

.menu_have_num {
  margin-bottom: 20px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}

.sub_menu_period {
  display: flex;
  flex-direction: column;

  .sub_period_title {
    font-style: normal;
    font-weight: 550;
    font-size: 16px;
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ebeef5;
  }

  .sub_period_item {
    display: flex;
    flex-direction: column;
    padding: 18px 20px 18px 20px;
    border-bottom: 1px solid #ebeef5;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #999999;
    cursor: pointer;

    .single_item_top {
      padding-left: 40px;
      padding-right: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &:hover {
      background: rgba(34, 86, 246, 0.05);
    }
  }
}

.btn_course_class {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 5px;
  position: relative;
  z-index: 99;
  padding-left: 40px;
  padding-right: 40px;

  .course_class_item {
    color: #becadb;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      color: #2256f6;
    }
  }

  .course_class_item .iconfont {
    font-size: 16px;
  }

  .course_class_item+.course_class_item {
    margin-left: 20px;
  }
}

.icon-audio {
  color: #cb4ef7;
  font-size: 24px;
}

.icon-img {
  color: #0fb48c;
  font-size: 24px;
}

.icon-live {
  color: #fe2c55;
  font-size: 24px;
}

.icon-video_class {
  color: #3a5ef4;
}

.icon-icon_txt {
  color: #fccc5a;
}

.icon-excel {
  color: #5acc9b;
}

.icon-word {
  color: #3cacff;
}

.icon-ppt {
  color: #ff6a4d;
}

.icon-pdf {
  color: #f10707;
}

.course_cell_valid {
  margin-top: 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  .course_tip {
    letter-spacing: 0.32em;
  }
}

.tag_success {
  background: rgba(88, 184, 92, 0.1);
  border-radius: 5px;
  color: #58b85c;
  padding: 4px 10px;
  margin-left: 10px;
}

.cover_teacher {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  cursor: pointer;

  &+.cover_teacher {
    transition: all 0.3s;
    margin-left: 3px;
  }

  &.hover {
    transform: scale(1.5);
    // border: 1px solid #2256F6;
    // box-shadow: 0px 5px 15px rgba(54, 41, 183, 0.06);
  }
}

.course_cover {
  position: relative;
}

.update_status {
  position: absolute;
  padding: 4px 9.5px;
  border-radius: 5px;
  color: #ffffff;
  right: 10px;
  top: 10px;

  &.success {
    background: #19cf8a;
  }

  &.danger {
    background: #ff4844;
  }
}

.course_price_info {
  margin-top: 10px;
  margin-bottom: 12px;
  background: #f5f5f5;
  padding: 13px 10px 17px;

  .course_tip {
    letter-spacing: 0.6em;
  }
}

.course_tip {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
}

.teacher_warp_item {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 10px;
  height: 40px;

  &+.teacher_warp_item {
    margin-right: 10px;
  }

  .teacher_name {
    margin-left: 4px;
  }

  &:hover .teacher_name {
    color: #3d7fff;
  }
}

.flex_teacher {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 70px);

  .course_in_icon {
    width: 29px;
    cursor: pointer;
  }

  .course_cell_item.teacher_wrap {
    padding-right: 10px;
  }
}

.course_cell_item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  word-break: break-all;
  overflow: auto;
}

.course_cell_item.teacher_wrap {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  text-overflow: clip;
  overflow: hidden;
}

.valid_text {
  font-weight: 400;
  font-size: 14px;
  color: #f01414;
}</style>
